export default () => ({
  statusEventStart: undefined,
  fetchingEventEnd: undefined,
  fetchingEventEndSuccess: undefined,
  eventNumberIterator: 1,
  eventList: [],
});
